import { notification } from 'antd';

export const openNotification = (message, type, description = '') => {
    notification.open({
        message: message,
        description: description,
        type: type,
        duration: 3
    });
};